import { useTranslation } from "react-i18next";
import { ModifyDetail } from "../../../../redux/apiSpecifications/apiSubjects";
import { useMemo } from "react";

type SubjectDeletedPaymentMethodDescriptionDetails = {
  payment_type: string;
  payment_iban: string;
};

interface ISubjectDeletedPaymentMethodDescriptionProps {
  modifyDetailsJson: ModifyDetail[];
}

const SubjectDeletedPaymentMethodDescription = ({
  modifyDetailsJson,
}: ISubjectDeletedPaymentMethodDescriptionProps) => {
  const { t } = useTranslation();

  const getPaymentTypeLabel = (code: string): string => {
    const translations: Record<string, string> = {
      A: t("payment_type-A"),
      B: t("payment_type-B"),
    };

    return translations[code] || code;
  };

  const subjectDeletedPaymentMethodDescriptionDetails: SubjectDeletedPaymentMethodDescriptionDetails =
    useMemo(() => {
      return {
        payment_type: getPaymentTypeLabel(
          modifyDetailsJson.find((_) => _.key === "payment_type")?.value ?? ""
        ),
        payment_iban:
          modifyDetailsJson.find((_) => _.key === "payment_iban")?.value ?? "",
      };
    }, [modifyDetailsJson, t]);

  return (
    <>
      {t(
        "HISTORY-TEMPLATES.policy-subject-deleted-payment-method-description",
        {
            payment_iban:
            subjectDeletedPaymentMethodDescriptionDetails.payment_iban,
            payment_type: subjectDeletedPaymentMethodDescriptionDetails.payment_type,
        }
      )}
    </>
  );
};
export default SubjectDeletedPaymentMethodDescription;
